import styled from 'styled-components';

export default styled.div`
  background: ${(props) => props.background || '#334dfa'};
  color: ${(props) => props.color || '#fff'};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.2;
  text-transform: uppercase;
  border-radius: 5px;
  padding: 4px 7px;
`;
